var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteWebsiteLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 42,
    viewBox: "0 0 49 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 41.0968,
    rx: 7.16823,
    fill: "#C0D8D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0975 19.9433C36.0999 20.8413 35.7454 21.7035 35.112 22.3398C34.4786 22.9764 33.6182 23.3351 32.7201 23.3367C31.822 23.3384 30.9604 22.9832 30.3243 22.3491C29.6885 21.7149 29.3308 20.8543 29.3298 19.9562C29.3291 19.0582 29.6851 18.1968 30.3199 17.5615C30.9545 16.9264 31.8157 16.5694 32.7138 16.5694C33.6094 16.5694 34.4686 16.9244 35.103 17.5569C35.7371 18.1895 36.0948 19.0475 36.0975 19.9434V19.9433Z",
    fill: "url(#paint0_linear_28_33591)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4522 25.1845L35.2322 40.2026C35.1465 40.5913 34.804 40.8694 34.406 40.8735H31.0709C30.6729 40.8694 30.3303 40.5912 30.2444 40.2026L25.9758 25.1845C25.9211 24.9381 25.9819 24.6803 26.1411 24.4845C26.303 24.286 26.5462 24.1715 26.8023 24.1734H38.6255C38.8817 24.1715 39.1249 24.286 39.2867 24.4845C39.4459 24.6803 39.5069 24.9382 39.4522 25.1845Z",
    fill: "url(#paint1_linear_28_33591)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0163 21.3832C18.0163 22.3034 17.6505 23.186 16.9995 23.8362C16.3484 24.4865 15.4657 24.8516 14.5454 24.8506C13.6254 24.8498 12.7432 24.483 12.0934 23.8315C11.4438 23.1799 11.0798 22.2967 11.0815 21.3764C11.0833 20.4564 11.4506 19.5747 12.1029 18.9254C12.7552 18.2763 13.6387 17.913 14.559 17.9158C15.4767 17.9183 16.3562 18.2848 17.0043 18.9348C17.6523 19.5849 18.0164 20.4652 18.0164 21.3832H18.0163Z",
    fill: "url(#paint2_linear_28_33591)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0163 21.3832C18.0163 22.3034 17.6505 23.186 16.9995 23.8362C16.3484 24.4865 15.4657 24.8516 14.5454 24.8506C13.6254 24.8498 12.7432 24.483 12.0934 23.8315C11.4438 23.1799 11.0798 22.2967 11.0815 21.3764C11.0833 20.4564 11.4506 19.5747 12.1029 18.9254C12.7552 18.2763 13.6387 17.913 14.559 17.9158C15.4767 17.9183 16.3562 18.2848 17.0043 18.9348C17.6523 19.5849 18.0164 20.4652 18.0164 21.3832H18.0163Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2174 40.2298C23.2174 40.7087 22.8294 41.0968 22.3507 41.0968H6.76711C6.28821 41.0968 5.90015 40.7087 5.90015 40.2298C5.90015 30.1862 9.95551 32.273 11.7588 31.2968L10.2743 26.8528C10.1805 26.5903 10.2255 26.2981 10.3939 26.0756C10.5515 25.8455 10.8123 25.7076 11.0913 25.7071H18.0661C18.3478 25.7076 18.6115 25.8452 18.7734 26.0756C18.9368 26.3001 18.9813 26.5898 18.893 26.8528L17.4082 31.2968C19.1522 32.2733 23.2174 30.1863 23.2174 40.2298Z",
    fill: "url(#paint3_linear_28_33591)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2174 40.2298C23.2174 40.7087 22.8294 41.0968 22.3507 41.0968H6.76711C6.28821 41.0968 5.90015 40.7087 5.90015 40.2298C5.90015 30.1862 9.95551 32.273 11.7588 31.2968L10.2743 26.8528C10.1805 26.5903 10.2255 26.2981 10.3939 26.0756C10.5515 25.8455 10.8123 25.7076 11.0913 25.7071H18.0661C18.3478 25.7076 18.6115 25.8452 18.7734 26.0756C18.9368 26.3001 18.9813 26.5898 18.893 26.8528L17.4082 31.2968C19.1522 32.2733 23.2174 30.1863 23.2174 40.2298Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5494 12.8812L25.5261 15.2782C25.1329 15.7509 24.5498 16.0243 23.9348 16.0243C23.3198 16.0243 22.7367 15.7509 22.3433 15.2782L20.4056 12.9435C20.0585 12.5273 19.8819 11.995 19.9106 11.4539C19.9395 10.9126 20.1719 10.4023 20.5614 10.0254C20.9827 9.63709 21.5468 9.44247 22.1176 9.4884C22.691 9.53022 23.2198 9.81299 23.5729 10.2666L23.9776 10.749L24.32 10.3365C24.6567 9.91188 25.1419 9.63069 25.6778 9.54975C26.2136 9.46904 26.7602 9.59431 27.2071 9.90072C27.6481 10.2509 27.9288 10.7647 27.9852 11.3249C28.0587 11.8815 27.9012 12.4439 27.5495 12.8812H27.5494Z",
    fill: "#619D94"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.90015,
    y: 5.26816,
    width: 35.3947,
    height: 2.10683,
    rx: 1.05341,
    fill: "#619D94"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_33591",
    x1: 32.7137,
    y1: 16.5694,
    x2: 36.9986,
    y2: 19.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37645D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7463",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_33591",
    x1: 32.714,
    y1: 24.1734,
    x2: 42.4283,
    y2: 29.8804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37645D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7463",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_33591",
    x1: 12.5063,
    y1: 17.9157,
    x2: 18.838,
    y2: 25.0094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28_33591",
    x1: 9.45809,
    y1: 25.7071,
    x2: 23.2289,
    y2: 43.0676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteWebsiteLink);
export default __webpack_public_path__ + "static/media/inviteWebsiteLink.8d8cf8482281fff1299e304559b3e123.svg";
export { ForwardRef as ReactComponent };